import { ExternalLink } from "lucide-react";
import { ChartContainer } from "@/components/charts/ChartContainer";
import { formatFortalezaDate, formatNumber } from "@/utils/format";
import type { InstagramTopPost } from "@/services/marketing";
import { InstagramRemoteImage } from "../instagramImage";

interface Props {
  posts: InstagramTopPost[];
  loading?: boolean;
}

export function InstagramTopPostsPanel({ posts, loading }: Props) {
  return (
    <ChartContainer
      title="Top publicações"
      subtitle="Melhor desempenho no período (por alcance)"
      loading={loading}
      empty={!loading && posts.length === 0}
      emptyMessage="Nenhuma publicação no período selecionado."
      height="auto"
      className="min-h-[320px]"
    >
      <div className="flex flex-col gap-3">
        {posts.map((post, index) => (
          <div
            key={post.id}
            className="flex gap-3 rounded-lg border border-slate-100 bg-slate-50/80 p-3"
          >
            <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-brand-100 text-xs font-bold text-brand-700">
              {index + 1}
            </span>
            <InstagramRemoteImage
              url={post.thumbnailUrl}
              alt=""
              className="h-14 w-14 flex-shrink-0 rounded-md object-cover"
              fallback={
                <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-md bg-slate-200 text-[10px] text-slate-500">
                  {post.mediaType.slice(0, 4)}
                </div>
              }
            />
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <p className="line-clamp-2 text-xs text-slate-700">{post.caption}</p>
                {post.permalink && (
                  <a
                    href={post.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-shrink-0 text-slate-400 hover:text-brand-600"
                    aria-label="Abrir no Instagram"
                  >
                    <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                )}
              </div>
              <p className="mt-1 text-[10px] text-slate-400">
                {formatFortalezaDate(post.timestamp)}
              </p>
              <div className="mt-1.5 flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] text-slate-600">
                <span>
                  Alcance: <strong>{formatNumber(post.reach)}</strong>
                </span>
                <span>
                  Views: <strong>{formatNumber(post.views)}</strong>
                </span>
                <span>
                  Curtidas: <strong>{formatNumber(post.likes)}</strong>
                </span>
                <span>
                  Coment.: <strong>{formatNumber(post.comments)}</strong>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ChartContainer>
  );
}
